import { withInstall } from '@zoryn/utils'
import FormCreate from './src/form-create.vue'
import { zFormCreate as formCreateEngine } from './src/engine'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZFormCreate: SFCWithInstall<typeof FormCreate> =
  withInstall(FormCreate)
export default ZFormCreate

export * from './src/form-create'
export * from './src/types'
export { registerField, zFormCreate, FormCreateComponent, bindFormCreateEngine } from './src/engine'
export {
  bindZorynElAliases,
  bindZorynFormCreate,
  bindDesignerFormCreate,
} from './src/bind-components'
export { normalizeFormCreateOption } from './src/option'

export const parseJson = (
  json: string,
  mode?: boolean
) => formCreateEngine.parseJson(json, mode)
export const toJson = (
  rule: unknown,
  space?: string | number
) => formCreateEngine.toJson(rule as never, space)
export const maker = formCreateEngine.maker

export type FormCreateInstance = InstanceType<typeof FormCreate> & unknown
